import React from "react";

const Box = ({ subhed, value, growth, logo }) => {
  return (
    <div
      className="
        bg-[#424242] border border-[#424242] rounded-xl p-6 
        flex flex-col justify-between gap-3 w-full m-2 h-auto 
        transition-transform duration-200 ease-in-out
        hover:scale-[1.02] hover:shadow-[0_4px_10px_rgba(0,0,0,0.3)]
        max-w-[450px] md:max-w-full
      "
    >
      {/* Top Section */}
      <div className="flex justify-between items-center">
        <div className="flex flex-col gap-1.5">
          <p className="text-white/70 font-semibold text-base font-[Poppins,Nunito_Sans,sans-serif]">
            Total {subhed}
          </p>
          <div className="text-white text-[1.7rem] font-bold font-[Poppins,Nunito_Sans,sans-serif]">
            {value}
          </div>
        </div>
        <div>
          <img
            src={logo}
            alt=""
            className="w-10 h-10 object-contain md:w-9 md:h-9"
          />
        </div>
      </div>

      {/* Status Section */}
      {/* <div className="text-sm flex items-center justify-between">
        <div
          className={`flex items-center ${
            growth < 0 ? "text-red-500" : "text-lime-500"
          }`}
        >
          {growth < 0 ? (
            <span className="mr-1">↓</span>
          ) : (
            <span className="mr-1">↑</span>
          )}
          <span>{growth > 0 ? `+${growth}` : growth}%</span>{" "}
          <span className="text-white ml-1">from yesterday</span>
        </div>
      </div> */}
    </div>
  );
};

export default Box;
